<div class="mb-6">
  <h3 class="text-2xl font-bold text-base-content">
    {{ user.isEdit ? 'Edit account' : 'Create account' }}
  </h3>
  <p class="text-sm text-base-content/60 mt-1">
    {{
      user.isEdit
        ? 'Update profile details. Use Disable on the list to revoke app access.'
        : 'Provision an Admin, Rider, or Customer. They can only sign in to their app.'
    }}
  </p>
</div>

<div class="space-y-5">
  <div class="form-control">
    <div class="label">
      <span class="label-text font-medium">Role</span>
    </div>
    @if (editingStaff) {
      <fieldset class="space-y-2">
        <legend class="text-sm text-base-content/60 mb-2">Select all responsibilities for this account.</legend>
        @for(role of availableRoles; track role){
          <label class="flex items-center gap-3 rounded-lg border border-base-300 p-3">
            <input type="checkbox" class="checkbox checkbox-sm" [checked]="user.staffRoles?.includes(role)"
              [disabled]="!canChangeAccess || (role!=='superadmin' && !!user.staffRoles?.includes('superadmin'))" (change)="toggleRole(role,$any($event.target).checked)">
            <span>{{roleLabel(role)}}</span>
          </label>
        }
      </fieldset>
      <p class="mt-2 text-sm text-base-content/60">Selected roles combine within the assigned store. Super Admin already has full platform access.</p>
    } @else { <select
      class="select select-bordered w-full"
      [(ngModel)]="user.role"
      [disabled]="!canChangeAccess"
    >
      <option disabled value="">Pick a role</option>
      @if (isSuperAdmin) {
        <option value="superadmin">Super Admin — full platform control</option>
      }
      <option value="store_manager">Admin — store operations panel</option>
      <option value="picker">Picker — verify, pack and hand over orders</option>
      <option value="inventory_operator">Inventory Operator — receive stock and submit counts</option>
      <option value="finance">Finance — assigned-store refunds, payouts and reconciliation</option>
      @if (!user.isEdit) {
      <option value="rider">Rider — rider app only</option>
      <option value="user">Customer — customer app only</option>
      } @else if (user.role === 'rider' || user.role === 'user') {
      <option [value]="user.role">{{user.role === 'rider' ? 'Rider' : 'Customer'}}</option>
      }
    </select> }
  </div>

  @if (user.role) {
    <div class="form-control">
      <div class="label">
        <span class="label-text font-medium">Full name</span>
      </div>
      <input
        type="text"
        class="input input-bordered w-full"
        placeholder="Full name"
        [(ngModel)]="user.name"
      />
    </div>

    @if (needsStore()) {
      <div class="form-control">
        <div class="label">
          <span class="label-text font-medium">Assigned store</span>
        </div>
        <select class="select select-bordered w-full" [(ngModel)]="user.storeId" [disabled]="!canChangeAccess">
          <option disabled [ngValue]="undefined">Select a store</option>
          @for (store of stores; track store.id) {
            <option [ngValue]="store.id">
              {{ store.name }}{{ store.city ? ' (' + store.city + ')' : '' }}
            </option>
          }
        </select>
      </div>
    }

    @if (needsEmail()) {
      <div class="form-control">
        <div class="label">
          <span class="label-text font-medium">Work email</span>
        </div>
        <input
          type="email"
          class="input input-bordered w-full"
          placeholder="admin@supidoo.app"
          [(ngModel)]="user.email"
          [disabled]="user.isEdit"
        />
      </div>
    }

    @if (needsPhone()) {
      <div class="form-control">
        <div class="label">
          <span class="label-text font-medium">Mobile number</span>
        </div>
        <input
          type="tel"
          class="input input-bordered w-full"
          placeholder="10-digit mobile"
          [(ngModel)]="user.phone"
          [disabled]="user.isEdit"
        />
        <span class="mt-1 text-xs text-base-content/50">
          Used for OTP login on the {{ user.role === 'rider' ? 'rider' : 'customer' }} app.
        </span>
      </div>
    }

    @if (needsPassword()) {
      <div class="form-control">
        <div class="label">
          <span class="label-text font-medium">Temporary password</span>
        </div>
        <input
          type="password"
          class="input input-bordered w-full"
          placeholder="Share securely with the admin"
          [(ngModel)]="user.password"
        />
      </div>
    }

    @if (!user.isEdit) { <div class="flex items-center justify-between rounded-xl border border-base-200 p-4">
      <div>
        <p class="font-medium">Account active</p>
        <p class="text-sm text-base-content/60">
          Inactive accounts cannot sign in to any Supidoo app.
        </p>
      </div>
      <input
        type="checkbox"
        class="toggle toggle-success"
        [(ngModel)]="user.isActive"
      />
    </div> }
  }
</div>

<div class="divider my-6"></div>

<div class="modal-action flex justify-end gap-2">
  <button class="btn btn-ghost" (click)="close()" [disabled]="saving">Cancel</button>
  <button class="btn btn-primary" (click)="save()" [disabled]="saving || !user.role">
    @if (saving) {
      <span class="loading loading-spinner loading-sm"></span>
    }
    {{ user.isEdit ? 'Save changes' : 'Create account' }}
  </button>
</div>
